import React from 'react';
import classnames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Link from 'next/link';
import { PORDUCT_TAG_MAP } from '@/constants/global';
import ProductTag from '../ProductTag';
import styles from './index.module.scss';

type RecommendProductProps = {
  boxProductId: string;
  productName?: string;
  productLogo?: string;
  summary?: string;
  tagType?: number;
  className?: string;
};
const RecommendProductCard: React.FC<RecommendProductProps> = ({
  boxProductId,
  productLogo,
  productName,
  summary,
  tagType,
  className,
}) => {
  return (
    <Link href={`/cbndatabox-new/product/${boxProductId}`}>
      <a className={classnames(styles.card, className)}>
        <LazyLoadImage
          className={styles.logo}
          width="72"
          height="72"
          wrapperClassName={styles.lazyLoadImgWrapper}
          src={productLogo}
          placeholderSrc="//images.dtcj.com/cbndata/icon/loading.gif"
        />
        <div>
          <div className={styles.nameWrapper}>
            <h1 className={styles.name}>{productName}</h1>
            {!!tagType && (
              <ProductTag text={PORDUCT_TAG_MAP[tagType].text} bgColor={PORDUCT_TAG_MAP[tagType].bgColor} />
            )}
          </div>
          <p className={styles.description}>{summary}</p>
        </div>
      </a>
    </Link>
  );
};
export default RecommendProductCard;
